import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-8 mx-auto" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-3" }
const _hoisted_6 = { class: "mb-3 text-capitalize-first" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "col-sm-3 text-sm-end" }
const _hoisted_9 = { class: "form-check form-switch d-inline-block" }
const _hoisted_10 = ["id", "checked", "onChange"]
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "card card-body mb-3" }
const _hoisted_13 = { class: "mb-3 text-capitalize-first" }
const _hoisted_14 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_15 = { class: "form-label" }
const _hoisted_16 = { class: "text-muted d-block mb-2" }
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "d-flex flex-wrap gap-2 mt-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "text-muted small d-block" }
const _hoisted_23 = { class: "col-sm-3 text-sm-end" }
const _hoisted_24 = { class: "d-inline-flex align-items-center gap-3" }
const _hoisted_25 = ["title", "onClick"]
const _hoisted_26 = { class: "form-check form-switch d-inline-block mb-0" }
const _hoisted_27 = ["id", "checked", "onChange"]
const _hoisted_28 = { class: "col-sm-12" }
const _hoisted_29 = { class: "card card-body" }
const _hoisted_30 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_31 = { class: "mb-0 text-capitalize-first" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = {
  key: 0,
  class: "text-center"
}
const _hoisted_34 = { class: "small text-muted mb-2" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "form-label text-capitalize-first" }
const _hoisted_41 = {
  value: "",
  disabled: ""
}
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "form-label text-capitalize-first" }
const _hoisted_45 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-sm-6 mb-3" }
const _hoisted_48 = { class: "form-label text-capitalize-first" }
const _hoisted_49 = { value: "" }
const _hoisted_50 = { value: "CARD" }
const _hoisted_51 = { value: "PHONE" }
const _hoisted_52 = { class: "col-sm-6 mb-3" }
const _hoisted_53 = { class: "form-label text-capitalize-first" }
const _hoisted_54 = { value: "" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "mb-2" }
const _hoisted_57 = { class: "form-label text-capitalize-first" }
const _hoisted_58 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_59 = ["title", "disabled", "onClick"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "overflow-auto" }
const _hoisted_63 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_64 = { class: "text-capitalize-first" }
const _hoisted_65 = { class: "text-capitalize-first" }
const _hoisted_66 = { class: "text-capitalize-first" }
const _hoisted_67 = { class: "text-capitalize-first" }
const _hoisted_68 = { class: "text-capitalize-first" }
const _hoisted_69 = { class: "d-flex align-items-center gap-2" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "text-end" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { key: 0 }
const _hoisted_75 = {
  colspan: "6",
  class: "text-center text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.helper.trans('payment_instructions.other_settings_title')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherSettings, (setting) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: setting.id,
                    class: "row mb-2 align-items-center"
                  }, [
                    _createElementVNode("label", {
                      for: 'other-setting-' + setting.id,
                      class: "col-sm-9 col-form-label"
                    }, _toDisplayString(setting.title), 9, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("input", {
                          id: 'other-setting-' + setting.id,
                          class: "form-check-input",
                          type: "checkbox",
                          role: "switch",
                          checked: _ctx.isSettingChecked(setting),
                          onChange: ($event: any) => (_ctx.onSettingToggle(setting, $event))
                        }, null, 40, _hoisted_10)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.helper.trans('payment_instructions.page_design_title')), 1),
                (_ctx.availableLayoutsSetting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.availableLayoutsSetting.title), 1),
                      _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.helper.trans('payment_instructions.available_layouts_hint')), 1),
                      _createVNode(_component_Multiselect, {
                        "model-value": _ctx.selectedLayouts,
                        "onUpdate:modelValue": _ctx.onLayoutsChange,
                        options: _ctx.catalogLayoutIds,
                        "custom-label": _ctx.layoutLabel,
                        multiple: true,
                        searchable: true,
                        "select-label": "",
                        "deselect-label": "",
                        placeholder: _ctx.helper.trans('payment_instructions.select_layouts')
                      }, {
                        option: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.layoutLabel(props.option)), 1),
                            _createElementVNode("small", _hoisted_18, _toDisplayString(_ctx.layoutConditions(props.option)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["model-value", "onUpdate:modelValue", "options", "custom-label", "placeholder"]),
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogLayoutIds, (layoutId) => {
                          return _withDirectives((_openBlock(), _createElementBlock("button", {
                            key: 'preview-' + layoutId,
                            type: "button",
                            class: "btn btn-sm btn-outline-secondary",
                            onClick: ($event: any) => (_ctx.openPreview(layoutId))
                          }, [
                            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.layoutLabel(layoutId)), 1)
                          ], 8, _hoisted_20)), [
                            [_vShow, _ctx.layoutPreviews[layoutId]]
                          ])
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageDesignSettings, (setting) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: setting.id,
                    class: "row mb-2 align-items-center"
                  }, [
                    _createElementVNode("label", {
                      for: 'page-design-' + setting.id,
                      class: "col-sm-9 col-form-label"
                    }, [
                      _createTextVNode(_toDisplayString(setting.title) + " ", 1),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.helper.trans('payment_instructions.legacy_design_flag')), 1)
                    ], 8, _hoisted_21),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        (_ctx.settingPreviews[setting.id])
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-link p-0 text-secondary",
                              title: _ctx.helper.trans('payment_instructions.design_preview'),
                              onClick: ($event: any) => (_ctx.openPreview(setting.id))
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                            ]), 8, _hoisted_25))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("input", {
                            id: 'page-design-' + setting.id,
                            class: "form-check-input",
                            type: "checkbox",
                            role: "switch",
                            checked: _ctx.isSettingChecked(setting),
                            onChange: ($event: any) => (_ctx.onSettingToggle(setting, $event))
                          }, null, 40, _hoisted_27)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.helper.trans('payment_instructions.title')), 1),
                    _createElementVNode("small", _hoisted_32, _toDisplayString(_ctx.helper.trans('payment_instructions.hint')), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCreate())),
                    class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize"
                  }, _toDisplayString(_ctx.helper.trans('payment_instructions.create')), 1)
                ]),
                _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
                _createVNode(_component_b_modal, {
                  title: _ctx.helper.trans('payment_instructions.design_preview'),
                  modelValue: _ctx.previewModal,
                  "dialog-class": "modal-lg",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.previewModal = $event)),
                  "hide-footer": ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.previewImages.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.helper.trans(_ctx.previewImages[_ctx.previewIndex].caption)) + " · " + _toDisplayString(_ctx.previewIndex + 1) + " / " + _toDisplayString(_ctx.previewImages.length), 1),
                          _createElementVNode("img", {
                            src: _ctx.previewImages[_ctx.previewIndex].src,
                            class: "img-fluid rounded border",
                            style: {"max-height":"70vh"},
                            alt: ""
                          }, null, 8, _hoisted_35),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-secondary",
                              disabled: _ctx.previewIndex === 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previewIndex--))
                            }, _toDisplayString(_ctx.helper.trans('button.back')), 9, _hoisted_37),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-primary",
                              disabled: _ctx.previewIndex === _ctx.previewImages.length - 1,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewIndex++))
                            }, _toDisplayString(_ctx.helper.trans('button.next')), 9, _hoisted_38)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title", "modelValue"]),
                _createVNode(_component_b_modal, {
                  title: _ctx.helper.trans('payment_instructions.view_steps'),
                  modelValue: _ctx.viewModal,
                  "dialog-class": "modal-md",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.viewModal = $event)),
                  "hide-footer": ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ol", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewSteps, (step, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(step), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["title", "modelValue"]),
                _createVNode(_component_b_modal, {
                  title: _ctx.form.id ? _ctx.helper.trans('payment_instructions.edit') : _ctx.helper.trans('payment_instructions.create'),
                  modelValue: _ctx.createModal,
                  "dialog-class": "modal-lg",
                  "body-class": "pt-0",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.createModal = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.helper.trans('payment_instructions.payment_option')), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.paymentOption) = $event)),
                        class: "form-select form-select-sm"
                      }, [
                        _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.helper.trans('payment_instructions.select_payment_option')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentOptions, (opt) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: opt,
                            value: opt
                          }, _toDisplayString(_ctx.helper.trans('payment_options.' + opt)), 9, _hoisted_42))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.form.paymentOption]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.helper.trans('payment_instructions.payment_method')), 1),
                      _createVNode(_component_Multiselect, {
                        "model-value": _ctx.form.paymentMethod || null,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = (value) => _ctx.form.paymentMethod = value ?? ''),
                        options: _ctx.availablePaymentMethods,
                        "custom-label": (opt) => _ctx.helper.trans('pay_methods.' + opt),
                        multiple: false,
                        searchable: true,
                        "select-label": "",
                        "deselect-label": "",
                        placeholder: _ctx.helper.trans('payment_instructions.select_payment_method')
                      }, {
                        option: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_PayMethodIcon, {
                              "icon-class": "icon",
                              method: props.option
                            }, null, 8, ["method"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["model-value", "options", "custom-label", "placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.helper.trans('payment_instructions.requisite_type')), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.requisiteType) = $event)),
                          class: "form-select form-select-sm"
                        }, [
                          _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.helper.trans('payment_instructions.requisite_type_any')), 1),
                          _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.helper.trans('payment_instructions.requisite_type_card')), 1),
                          _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.helper.trans('payment_instructions.requisite_type_phone')), 1)
                        ], 512), [
                          [_vModelSelect, _ctx.form.requisiteType]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.helper.trans('payment_instructions.cross_border_currency')), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.crossBorderCurrency) = $event)),
                          class: "form-select form-select-sm"
                        }, [
                          _createElementVNode("option", _hoisted_54, _toDisplayString(_ctx.helper.trans('payment_instructions.cross_border_currency_any')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossBorderCurrencies, (currency) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: currency,
                              value: currency
                            }, _toDisplayString(currency), 9, _hoisted_55))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.form.crossBorderCurrency]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.helper.trans('payment_instructions.steps')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.steps, (step, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "d-flex align-items-center gap-2 mb-2"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((_ctx.form.steps[index]) = $event),
                            type: "text",
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('payment_instructions.step_placeholder', {n: index + 1})
                          }, null, 8, _hoisted_58), [
                            [_vModelText, _ctx.form.steps[index]]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-outline-danger",
                            title: _ctx.helper.trans('payment_instructions.remove_step'),
                            disabled: _ctx.form.steps.length <= 1,
                            onClick: ($event: any) => (_ctx.removeStep(index))
                          }, _cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                          ]), 8, _hoisted_59)
                        ]))
                      }), 128)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-secondary text-capitalize-first",
                        disabled: _ctx.form.steps.length >= 10,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addStep()))
                      }, _toDisplayString(_ctx.helper.trans('payment_instructions.add_step')), 9, _hoisted_60)
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.createModal = false)),
                      class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                    }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                    _createVNode(_component_LoaderWrapper, {
                      ref: "saveLoader",
                      zoom: 0.5
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: !_ctx.isFormValid,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save())),
                          class: "btn btn-outline-primary btn-sm text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.save')), 9, _hoisted_61)
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }, 8, ["title", "modelValue"]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("table", _hoisted_63, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.helper.trans('payment_instructions.payment_method')), 1),
                        _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.helper.trans('payment_instructions.payment_option')), 1),
                        _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.helper.trans('payment_instructions.requisite_type')), 1),
                        _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.helper.trans('payment_instructions.cross_border_currency')), 1),
                        _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.helper.trans('payment_instructions.steps')), 1),
                        _cache[18] || (_cache[18] = _createElementVNode("th", { class: "text-end" }, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_69, [
                              _createVNode(_component_PayMethodIcon, {
                                method: item.paymentMethod
                              }, null, 8, ["method"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('pay_methods.' + item.paymentMethod)), 1)
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans('payment_options.' + item.paymentOption)), 1),
                          _createElementVNode("td", null, _toDisplayString(item.requisiteType ? _ctx.helper.trans('payment_instructions.requisite_type_' + item.requisiteType.toLowerCase()) : _ctx.helper.trans('payment_instructions.requisite_type_any')), 1),
                          _createElementVNode("td", null, _toDisplayString(item.crossBorderCurrency ?? _ctx.helper.trans('payment_instructions.cross_border_currency_any')), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-dark",
                              onClick: ($event: any) => (_ctx.openView(item))
                            }, [
                              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa fa-eye" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(item.steps.length), 1)
                            ], 8, _hoisted_70)
                          ]),
                          _createElementVNode("td", _hoisted_71, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-dark me-2",
                              onClick: ($event: any) => (_ctx.openEdit(item))
                            }, _toDisplayString(_ctx.helper.trans('payment_instructions.edit')), 9, _hoisted_72),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-danger",
                              onClick: ($event: any) => (_ctx.showDeleteModal(item))
                            }, _toDisplayString(_ctx.helper.trans('payment_instructions.delete')), 9, _hoisted_73)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.response.items.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                            _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.helper.trans('payment_instructions.no_instructions')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[13] || (_cache[13] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[14] || (_cache[14] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": _ctx.helper.trans('button.back'),
                        "next-text": _ctx.helper.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}